module.exports = __webpack_public_path__ + "img/indu_18.2f2258a7.png";